export const APPLICATION_GLOBAL_DISCLAIMER =
  'Participating purchase options may have different information and underwriting requirements. Accordingly, not all information requested through this form may be provided to or used by every participating purchase option.';
